/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import { OilIcon } from '@commander-services/cmd-icon';
import { isOnlinePanelOpenAtom, IVehicleOnlinePanels, onlinePanelAtom } from '../OnlinePanelState';
import { ICustomWidgetProps } from './Widget';
import RemoveButton from './RemoveButton';

export default function OilLevelLowWidget(props: ICustomWidgetProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [widgetData, setWidgetData] = React.useState<boolean | null>(true);

  const vehicleId = useRecoilValue<number | false>(isOnlinePanelOpenAtom);
  const onlinePanelData = useRecoilValue<IVehicleOnlinePanels>(onlinePanelAtom);

  React.useMemo(() => {
    if (!props.isMockupMode) {
      const onlinePanel = onlinePanelData[Number(vehicleId)];

      if (
        onlinePanel &&
        typeof vehicleId === 'number' &&
        typeof onlinePanel.oilLevelLow === 'boolean'
      ) {
        setWidgetData(onlinePanel.oilLevelLow);
      } else {
        setWidgetData(null);
      }
    }
  }, [onlinePanelData, props.isMockupMode, vehicleId]);
  let widgetTooltip;

  if (widgetData === null) {
    widgetTooltip = f({ id: 'enum.onlineMap.widget.types.oilLevelLow' });
  } else if (widgetData === false) {
    widgetTooltip = f({ id: 'widget.oilLevelLow.tooltip.no' });
  } else if (widgetData === true) {
    widgetTooltip = f({ id: 'widget.oilLevelLow.tooltip.yes' });
  }

  if (!props.isInGrid && props.isMockupMode) {
    widgetTooltip = f({ id: 'onlineTemplates.subPage.section.widgets.tooltip' });
  }

  const onDragStart = props.isInGrid ? undefined : props.onDragCallback;

  const renderWidget = () => {
    if (widgetData === true && !props.isMockupMode) {
      return <OilIcon className="e-widget-icon" data-cy="oil-widget-active" />;
    }
    return <OilIcon className="e-widget-icon" data-cy="oil-widget-mode" color="#737373" />;
  };

  return (
    <div
      data-cy="oil-widget"
      className={`b-widget b-widget--${props.data.rowSize}x${props.data.columnSize}
      widget-grid-name-${props.data.gridName} ${props.isInGrid ? '' : 'droppable-element'}`}
      draggable={!props.isInGrid}
      onDragStart={onDragStart}
      title={widgetTooltip}
      style={{ position: 'relative' }}
    >
      {props.isInGrid && (
        <RemoveButton
          dataCy="oil-widget-in-grid"
          onRemoveCallback={props.onRemoveCallback}
          gridName={props.data.gridName}
        />
      )}
      {props.data.columnSize === 1 && props.data.rowSize === 1 && widgetData !== null ? (
        renderWidget()
      ) : (
        <OilIcon className="e-widget-icon" color="#b7b7b7" />
      )}
    </div>
  );
}
